import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {IAuthResponse} from "../../models/auth"
import tokenService from "../../services/TokenService"
import {IValidationFieldErrorItem} from "../../models/validation"
import {IUser} from "../../models/IUser"

const {tokenData, token} = tokenService

interface IAuthState {
  isAuthenticated: boolean
  isLoginProcess: boolean
  error: any
  user: IUser
}

const initialState: IAuthState = {
  isAuthenticated: Boolean(token),
  isLoginProcess: false,
  error: {},
  user: {
    id: tokenData?.id ?? null,
    fio: tokenData?.fio ?? '',
    email: tokenData?.email ?? '',
    phone: tokenData?.phone ?? '',
    role_id: tokenData?.role_id ?? null,
    brigade_id: tokenData?.brigade_id ?? null,
    status_id: tokenData?.status_id ?? null,
    created_at: tokenData?.created_at ?? null
  }
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginProcess(state) {
      state.isLoginProcess = true
    },
    login(state, action: PayloadAction<IAuthResponse>) {

      state.isLoginProcess = false
      tokenService.setToken(action.payload.access_token)
      const {tokenData, token} = tokenService

      state.isAuthenticated = Boolean(token)
      state.isLoginProcess = false
      state.error = {}
      state.user.id = tokenData.id
      state.user.fio = tokenData.fio
      state.user.phone = tokenData.phone
      state.user.email = tokenData.email
      state.user.role_id = tokenData.role_id
      state.user.brigade_id = tokenData.brigade_id
      state.user.status_id = tokenData.status_id
      state.user.created_at = tokenData.created_at
    },
    userUpdate(state, action: PayloadAction<IAuthResponse>) {
      tokenService.setToken(action.payload.access_token)
      const {tokenData} = tokenService

      state.user.fio = tokenData.fio
      state.user.phone = tokenData.phone
      state.user.email = tokenData.email
    },
    fieldError(state, action: PayloadAction<IValidationFieldErrorItem[]>) {
      const fieldErrors = action.payload
      state.isLoginProcess = false

      if (fieldErrors && fieldErrors.length) {
        fieldErrors.forEach(error => {
          state.error[error.field] = error.message
        })
      }
    },
    clearFieldError(state, action: PayloadAction<string>) {
      delete state.error[action.payload]
    },
    clearError(state) {
      state.error = {}
    },
    logout(state) {
      tokenService.clearTokens()
      const {token} = tokenService
      state.isAuthenticated = Boolean(token)
      window.location.href = "/"
    }
  }
})

export default authSlice.reducer